import { GUARANTEES_APPLICATION_MANUAL_TASK_QUERY_PARAM } from '~/modules/guarantees/form/client/constants.ts';
import { buildGuaranteesApplicationStep3Path } from '~/modules/guarantees/utils.ts';
import { GuaranteesApplicationStatus } from '~/store/guarantees/types.ts';

export const getUdbtfIssuanceTermsStep3Path = ({
  applicationId,
  applicationStatus,
  contragentId,
  isManualTaskMode,
  reviewMode,
}: {
  applicationId: string;
  applicationStatus?: GuaranteesApplicationStatus | string | null;
  contragentId: string;
  isManualTaskMode: boolean;
  reviewMode: string;
}): string | null => {
  if (applicationStatus !== GuaranteesApplicationStatus.IN_PROGRESS_UDBTF_ISSUANCE_TERMS) {
    return null;
  }

  const step3Path = buildGuaranteesApplicationStep3Path(
    applicationId,
    contragentId,
    true,
    reviewMode
  );
  if (!isManualTaskMode) {
    return step3Path;
  }
  const separator = step3Path.includes('?') ? '&' : '?';

  return `${step3Path}${separator}${GUARANTEES_APPLICATION_MANUAL_TASK_QUERY_PARAM}=true`;
};
